import { mapApplePayCardType } from 'utils/payment/map-apple-pay-card-type';

import { ICommitOptions } from '../use-commit-order';

/**
 * This function needed for the TH POS in order to commit an order successfully.
 * It is used to override the Credit Card Type to the one used while making an Apple Pay purchase.
 * Instead of sending the credit type of 'APPLE_PAY' || 'GOOGLE_PAY', we're sending the underlying credit card type used for the purchase.
 * If the user is paying with a Credit Card, we don't override and we're sending the credit type used.
 */
export const mapCardType = (options: ICommitOptions) => {
  // If it's an Google Pay transaction, get the creditType from the options & override the credit type on the commit input
  if (options?.googlePayDetails) {
    return options?.googlePayDetails?.PaymentMethodData?.paymentType;
  }
  // If it's an Apple Pay transaction, get the creditType from the options & override the credit type on the commit input
  if (options?.applePayDetails) {
    return mapApplePayCardType(options?.applePayDetails?.PaymentMethodData?.paymentType);
  }
  // If the user use a CC, return the expected credit type
  return options.creditType;
};
